export default "__VITE_ASSET__38a33339__"